module.exports = __webpack_public_path__ + "static/media/88cd516c.jpg";